// extracted by mini-css-extract-plugin
export default {"footerSlim":"Footer_footerSlim__ikZ47","footerLinks":"Footer_footerLinks__Mudwb","footerSocials":"Footer_footerSocials__5C-+3","footerNote":"Footer_footerNote__XKEVD"};